import React, { useState, useEffect } from "react";
import { AddFileDialog } from "../shared/addFileDialog";
import { preauthorizationService } from "../../services/api/preauthorization.service";
import { alertService } from '../../services/helpers/alert.service';
import { filesService } from "../../services/api/files.service";
import { utils } from "../../services/helpers/utils";

export const PreauthorizationFiles = (props) => {

    const [fileList, setFileList] = useState([]);
    const [visibleFileDialog, setVisibleFileDialog] = React.useState(false);

    useEffect(() => {
        if (props && props.id) {
            preauthorizationService.getFiles({ preauthorizationId: props.id })
                .then(response => {
                    if (response) {
                        setFileList(response);
                    }
                });
        }
    }, [props.refresh]);


    const toggleFileDialog = () => {
        setVisibleFileDialog(!visibleFileDialog);
    };

    const updateLists = (list) => {
        setFileList(list);
        props.setFisiere(list);
        if (props.setIsModified) {
            props.setIsModified(true);
        }
    }

    const addFile = (file) => {
        var customFile = {
            descriere: file.descriere,
            nume: file.numeFisier,
            fisier: file.rawFile,
            dimensiune: file.rawFile.size
        }
        var newFile = [...fileList, customFile]
        updateLists(newFile);
    }

    function handleDelete(index) {
        alertService.confirm("Atentie", "Esti sigur ca vrei sa stergi aceast fisier?"
            , () => {
                var list = [...fileList];
                list.splice(index, 1);
                updateLists(list);
            }
            , () => { return; }
        );
    }

    const handleView = (item) => {
        // Daca are downloadId inseamna ca fisierul a fost salvat in baza de date
        if (item.hasOwnProperty("downloadId")) {
            filesService.getFile({ queryString: item.downloadId, partener: props.partener })
                .then(response => {
                    if (response) {
                        utils.viewResponse(response, item.nume)
                    }
                })


        }
        else {
            utils.downloadFilebyName(item.fisier, item.nume);
        }
        return;
    }

    const handleDownload = (item) => {
        // Daca are downloadId inseamna ca fisierul a fost salvat in baza de date
        if (item.hasOwnProperty("downloadId")) {
            filesService.downloadFile({ queryString: item.downloadId });
        }
        else {
            utils.downloadFilebyName(item.fisier, item.nume);
        }
        return;
    }

    const handleSaveFile = (item) => {
        utils.saveFile(item.fisier, item.nume);
    }



    return (
        <>
            <div className="pt10">
                <fieldset>
                    <legend className="pb5">Fisiere ; numar  minim=<span name="nr_minim_fisiere">0</span></legend>
                    <table className="tbl tbladd mt5" name="lista_fisiere" width="100%">
                        <thead>
                            <tr>
                                <th className="col120">Nume fisier</th>
                                <th className="col240">Descriere</th>
                                <th className="col240">Dimensiune</th>
                                <th className="col40 center">Sterge</th>
                                <th className="col40 center">Vizualizeaza</th>
                                <th className="col40 center">Download</th>
                            </tr>
                        </thead>
                        <tbody>
                            {fileList.map((file, index) => (
                                <tr key={index}>
                                    <td name="nume_fisier"> {file.nume} </td>
                                    <td name="descriere"> {file.descriere} </td>
                                    <td name="dimensiune"> {file.dimensiune} </td>
                                    <td>
                                        {!props.finalizare && (
                                            <span className="icon sterge center" name="fisier_del" onClick={() => handleDelete(index) }></span>
                                        )}
                                    </td>
                                    <td>
                                        <span className="icon deschide center" name="fisier_view" onClick={() => handleView(file)}> </span>
                                    </td>
                                    <td>
                                        <span className="icon download center" name="fisier_down" onClick={() => handleDownload(file)}></span>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    {!props.finalizare && (
                        <button name="adauga_fisier"
                            className="btn"
                            onClick={toggleFileDialog}
                        >Adauga fisier</button>
                    )}
                    <p className="paragraf red mt15">Campurile marcate cu * sunt obligatorii.</p>
                </fieldset>
            </div>

            {visibleFileDialog && <AddFileDialog toggleDialog={toggleFileDialog} addFile={addFile} />}
        </>
    );
}
